export const setBodyClass = (className, add = true) => {
    if (add) {
      document.body.classList.add(className);
    } else {
      document.body.classList.remove(className);
    }
  };